import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PremiumPrice } from 'src/api/internal/schema';
import { useTabRetention } from '../../hooks/useTabRetention';
import { HeroSection } from '../HeroSection';
import { PlansPanel } from '../PlansPanel';
import { MobileTestimonial } from '../MobileTestimonial';
import { MobileStickyBar } from '../MobileStickyBar';
import * as S from './styles';

export const CondensedUpsellPage: FC<{
  prices: PremiumPrice[];
  selectedPrice: PremiumPrice | null;
  setSelectedPrice: (price: PremiumPrice) => void;
  onSubscribe: () => void;
  onClose?: () => void;
  onBack?: () => void;
}> = ({ prices, selectedPrice, setSelectedPrice, onSubscribe, onClose, onBack }) => {
  const intl = useIntl();
  useTabRetention();
  const yearlyPlan = prices.find(p => p.paymentPeriod === 'year');
  const currency = prices[0]?.currency || 'USD';

  const pricePerDay = useMemo(() => {
    if (!yearlyPlan) return undefined;
    const daily = Math.ceil((yearlyPlan.finalPrice * 100) / 365) / 100;
    return intl.formatNumber(daily, { style: 'currency', currency });
  }, [yearlyPlan, intl, currency]);

  return (
    <>
      <S.Page data-testid="new-plans-page">
        <HeroSection onBack={onBack} pricePerDay={pricePerDay} />
        <PlansPanel
          prices={prices}
          selectedPrice={selectedPrice}
          setSelectedPrice={setSelectedPrice}
          onSubscribe={onSubscribe}
          onClose={onClose}
        />
      </S.Page>
      <S.MobileContent>
        <MobileTestimonial />
      </S.MobileContent>
      <MobileStickyBar onSubscribe={onSubscribe} />
    </>
  );
};
